/* import __COLOCATED_TEMPLATE__ from './snippet-mobile-chat.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();